import { Launch } from "@models/launch.model.ts";
import { httpRequest } from "../../http.ts";
import { LaunchSerializer } from "@models/serializers/launchSerializer.ts";

/** Set or clear a campaign's go-live date, the billing boundary (MPN-1685, MPN-1752).
 *  Null clears it: every conversion then loads as a pre-convert until the next
 *  non-paused publish stamps a new date. The server refuses a future date and a
 *  population with billed months. */
export class CommandSetLaunchGoLiveDate {
  async run(launchId: number, goLiveDate: string | null): Promise<Launch> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/go-live-date/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: { go_live_date: goLiveDate },
    });
    return new LaunchSerializer().deserialize(response);
  }
}
